var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: rgba(5, 193, 103, .2);\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: rgba(5, 193, 103, .6);\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 131,
    height: 34,
    rx: 5,
    ry: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.5,
    y: 0.5,
    width: 130,
    height: 33,
    rx: 4.5,
    ry: 4.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.0667,12.8804h3.9458c1.8467,0,3.1543,1.187,3.1543,2.8789,0,1.6904-1.3076,2.8779-3.1543,2.8779h-1.6191v2.4824h-2.3267v-8.2393ZM54.8206,16.5269c.5518,0,.9473-.3242.9473-.7676,0-.4443-.3955-.7676-.9473-.7676h-1.4272v1.5352h1.4272Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.3118,20.0161h-2.8667l-.4194,1.1035h-2.6265l3.166-8.2393h2.6265l3.1665,8.2393h-2.6265l-.4199-1.1035ZM63.6521,18.3013l-.7676-2.0029-.7798,2.0029h1.5474Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.1423,12.8804h2.3262v8.2393h-2.3262v-8.2393Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.947,12.8804h3.0703c2.8779,0,4.916,1.7031,4.916,4.1133s-2.0381,4.126-4.916,4.126h-3.0703v-8.2393ZM75.4001,19.0093c1.248,0,2.1348-.8398,2.1348-2.0156s-.8867-2.002-2.1348-2.002h-1.127v4.0176h1.127Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/Paid.0c1872a0fb1c87a2a0fbcc52f7aa381c.svg";
export { ForwardRef as ReactComponent };